import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

interface AddNewTestItemProps {
    showModal: boolean
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
    itemType: string,
    createNewitem: (arg0: string) => true | string
}

export const AddNewTestItem = (props: AddNewTestItemProps) => {
    const [newItemName, setNewItemName] = useState<string>('');
    const [addItemError, setAddItemError] = useState<string>('');

    const addNewItem = () => {
        let addResult = props.createNewitem(newItemName);

        if (addResult === true) {
            props.setShowModal(false);
        }
        else {
            setAddItemError(addResult);
        }
    }
    return (
        <Dialog open={props.showModal} onClose={() => props.setShowModal(false)}>
                <DialogTitle>Enter a name for your new {props.itemType}</DialogTitle>
            <DialogContent>
                {addItemError !== '' ? <DialogContentText>{addItemError}</DialogContentText> : <></>}
                <TextField sx={{marginTop: '1rem'}} label={`${props.itemType} name`} onChange={(e) => setNewItemName(e.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { setAddItemError(''); props.setShowModal(false); }}>
                    Close
                </Button>
                <Button disabled={newItemName === ''} onClick={() => { setAddItemError(''); addNewItem() }}>
                    Add {props.itemType}
                </Button>
            </DialogActions>
        </Dialog>
    )
}